module.exports = __webpack_public_path__ + "img/stop.ce400fd9.svg";